import React from 'react';
import { DashboardPageHeader } from './PerformanceDashboardSkeleton.js';
import { DASHBOARD_MESSAGES } from './dashboardConstants.js';

/**
 * 画面の部品が描けなかったときの表示（SCR-P-001 §6.3「画面の部品の読み込みの失敗」）。
 * 見出しと「← マイページに戻る」は出す。「再読み込み」はページ全体を読み直す
 * （遅延読み込みに一度失敗した部品は、同じ画面の中では読み込みをやり直せないため）
 */
export function DashboardLoadError() {
    return (
        <div className="performance-dashboard tablet-ready-page">
            <DashboardPageHeader />
            <div className="dashboard-section-message" role="alert">
                <p>{DASHBOARD_MESSAGES.pageLoadFailed}</p>
                <button type="button" className="chart-card-reload" onClick={() => window.location.reload()}>
                    {DASHBOARD_MESSAGES.reload}
                </button>
            </div>
        </div>
    );
}

/**
 * 本画面の範囲だけに置く受け皿（ErrorBoundary）。React 19 では、受け皿の無い描画中の例外でアプリ全体が外れるため、
 * 共通ヘッダとほかの画面を残すよう /dashboard の中に置く（SCR-P-001 §6.3）。
 * 遅延読み込みのファイルが取れないとき（デプロイ前に開いていたタブ・通信の失敗）のほか、本画面の描画中の例外も受ける
 */
class DashboardErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    render() {
        return this.state.failed ? <DashboardLoadError /> : this.props.children;
    }
}

export default DashboardErrorBoundary;
